import { create } from 'zustand';

interface UIState {
  isCommandPaletteOpen: boolean;
  isSidebarCollapsed: boolean;
  activeView: 'chat' | 'tasks' | 'calendar' | 'planner';
  
  // Actions
  toggleCommandPalette: () => void;
  setCommandPaletteOpen: (open: boolean) => void;
  toggleSidebar: () => void;
  setActiveView: (view: UIState['activeView']) => void;
}

export const useUIStore = create<UIState>((set) => ({
  isCommandPaletteOpen: false,
  isSidebarCollapsed: false,
  activeView: 'chat',

  toggleCommandPalette: () =>
    set((state) => ({ isCommandPaletteOpen: !state.isCommandPaletteOpen })),

  setCommandPaletteOpen: (isCommandPaletteOpen) => set({ isCommandPaletteOpen }),

  toggleSidebar: () =>
    set((state) => ({ isSidebarCollapsed: !state.isSidebarCollapsed })),

  setActiveView: (activeView) => set({ activeView }),
}));

// Global keyboard shortcut for command palette
if (typeof window !== 'undefined') {
  window.addEventListener('keydown', (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
      e.preventDefault();
      useUIStore.getState().toggleCommandPalette();
    }
  });
}

